import {useState,useEffect,Fragment} from "react"
import {formatDate} from "../hooks/Commons"
import useApi from "../hooks/useApi"
import useBoard from "../hooks/useBoard"
import useDialog from "../hooks/useDialog"
import useToast from "../hooks/useToast"
import useRefresh from "../hooks/useRefresh"
import Board from "../components/Board"
import BoardContent from "../components/BoardContent"
import BoardActions from "../components/BoardActions"
import ButtonAction from "../commons/ButtonAction"
import DataBlock from "../components/DataBlock"
import DataRows from "../components/DataRows"
import DataList from "../components/DataList"
import DataListItem from "../components/DataListItem"
import DataPerson from "../components/DataPerson"

export default function ImportsPersonsData({params}){

    const section="imports-persons-data"
    const requestApi=useApi()
    const [ready,setReady]=useState(0)
    const {loadBoard}=useBoard()
    const {changeDialog,manageDialog}=useDialog()
    const {changeToast}=useToast()
    const {refresh}=useRefresh()
    const [data,setData]=useState("")

    const loadData=()=>{
        requestApi("imports_persons/info",{
                reference:params.reference
            })
            .then(data=>{
                setData(data.data)
                setReady(1)
            })
    }

    useEffect(()=>{
        loadData()
    },[])

    useEffect(()=>{
        loadData()
    },[params.reference])

    const undo=()=>{
        changeDialog("undo_import","",()=>{
            requestApi("imports_persons/undo",{
                    reference:data.id
                })
                .then(data=>{
                    manageDialog("hide")
                    if(data.status=="success"){
                        changeToast("undone_import","")
                        refresh({board:"imports-persons",close:"imports-persons-data"})
                    }else{
                        changeToast("generic_error","")
                    }
                })
        })
    }

    return(
        <Board params={params} ready={ready}>
            <BoardActions
                actionsLeft={
                    <Fragment>
                        <ButtonAction label="Deshacer" icon="undo" style="alt" clickEvent={undo} />
                    </Fragment>
                }
                actionsRight={<ButtonAction label="Editar" icon="edit" clickEvent={()=>{loadBoard({params:{alias:"imports-persons-edit",level:2,theme:"rabbit",reference:params.reference,mode:"edit"}})}} />} />
            <BoardContent>
                {data &&
                <div className="board-data board-data-xl">
                    <DataBlock title="" style="bluish">
                        <DataRows items={[
                            {label:"Nombre",content:data.name,style:"bold"},
                            {label:"Fecha de importación",content:formatDate(data.created,"semilong"),style:""}
                        ]} />
                    </DataBlock>
                    <DataBlock title={data.persons.quantity+(data.persons.quantity==1?" persona importada":" personas importadas")} style="white">
                        <DataList>
                            {data.persons.persons.map((item,i)=>{
                                return(
                                    <DataListItem key={i} left={<DataPerson context="imports" item={item} index={i} />} right={""} />
                                )
                            })}
                        </DataList>
                    </DataBlock>
                </div>}
            </BoardContent>
        </Board>
    )
}